import { IconButton, IconName, Typography, Body, Stack, StackItem } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { TextKey, DataTestId } from '@mews-commander/enums';
import { WithAvailabilityBlockId } from '@mews-commander/types';
import { useCommanderThunkDispatch } from '@mews-commander/utils';
import { RateName } from '../../../components/commander-ui';
import { showAvailabilityBlockRateDetail } from '../actions/availabilityBlock';

interface RateInfoProps extends WithAvailabilityBlockId {
    rateId: string;
    editable: boolean;
}

const RateInfo = ({ rateId, availabilityBlockId, editable }: RateInfoProps) => {
    const dispatch = useCommanderThunkDispatch();

    const openAvailabilityBlockRateDetail = () => {
        dispatch(showAvailabilityBlockRateDetail({ availabilityBlockId }));
    };

    return (
        <Stack spacing="100" distribution="space-between" itemAlignment="center">
            <StackItem minWidth="0" grow>
                <Typography textStyle="bodyMediumStrong" variant="secondary" as="div">
                    <LocalizedText textKey={TextKey.Rate} />
                </Typography>
                <Body whiteSpace="nowrap" ellipsis>
                    <RateName rateId={rateId} />
                </Body>
            </StackItem>
            {editable && (
                <IconButton
                    icon={IconName.Edit}
                    variant="ghost"
                    onClick={openAvailabilityBlockRateDetail}
                    data-test-id={DataTestId.AvailabilityBlockRateEdit}
                    type="submit"
                />
            )}
        </Stack>
    );
};

export default RateInfo;
